"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
var Footer = function Footer(_ref) {
    var _ref$siteTitle = _ref.siteTitle, siteTitle = _ref$siteTitle === void 0 ? '' : _ref$siteTitle;
    return /*#__PURE__*/ react_1.default.createElement("div", {
        className: "footer"
    }, /*#__PURE__*/ react_1.default.createElement("span", {
        className: "block"
    }, "\xA9 ", new Date().getFullYear(), " ", siteTitle), /*#__PURE__*/ react_1.default.createElement("span", {
        className: "block"
    }, /*#__PURE__*/ react_1.default.createElement("small", null, " </>", " Powered by ", " ", /*#__PURE__*/ react_1.default.createElement("a", {
        href: "https://www.gatsbyjs.org"
    }, "Gatsby"), " and", " ", /*#__PURE__*/ react_1.default.createElement("a", {
        href: "https://github.com/wangonya/the-plain-gatsby"
    }, "The Plain"))));
};
exports.default = Footer;
